import * as date from 'date-fns'

export function strftime(d: string | number | Date, format: string, {utc = false} = {}) {
  if (typeof d === 'string' || typeof d === 'number') {
    d = new Date(d)
  }
  if (utc) {
    d = new Date(d.valueOf() + 60 * d.getTimezoneOffset() * 1000)
  }
  return date.format(d, format)
}

export function daysUntil(n: number) {
  if (n <= 0) {
    return 'today'
  } else if (n === 1) {
    return 'tomorrow'
  }
  return `${n} days`
}

export function daysAfter(n: number) {
  if (n === 0) {
    return 'today'
  } else if (n === 1) {
    return '1 day ago'
  }
  return `${n} days ago`
}

export function assetUrl(url: string | undefined, {absolute = 'https://fotolog.tfks.net'} = {}) {
  /* eslint-disable no-param-reassign */
  if (!url) {
    // if this fails, email could have a bad time
    url = '/assets/img/pixel.png'
  }
  if (url.startsWith('/')) {
    if (!url.startsWith('/assets')) {
      url = `/assets${url}`
    }
    if (absolute) {
      url = `${absolute}${url}`
    }
  }
  return url
}

export function assetUpdated(url: string) {
  if (url) {
    const m = url.match(/-(\d+)(\.|$)/u)
    if (m) {
      return strftime(Number(m[1]), 'MMM dd, yyyy')
    }
  }
  return ''
}

// const xmarkdown2html = _.memoize(async () => {
//   const {unified} = await import('unified')
//   const {default: parser} = await import('remark-parse')
//   const {default: gfm} = await import('remark-gfm')
//   const {default: rehype} = await import('remark-rehype')
//   const {default: document} = await import('rehype-document')
//   const {default: format} = await import('rehype-format')
//   const {default: stringify} = await import('rehype-stringify')
//   const x = await unified()
//   return x.use(parser).use(gfm).use(rehype).use(document).use(format).use(stringify)
// })

// async function markdown2html(text) {
//   const x = await xmarkdown2html(text)
//   return await x.process(text)
// }
